let inImperial = () => {
    if (localStorage.getItem('unit') === 'mi') {
      return true;
    }
    return false;
  };
  
let unitLabels = () => {
    let pace = "min/km";
    let distance = "km";
    let elevation ="m";
  
    if (localStorage.getItem('unit') === 'mi') {
      pace = "min/mi";
      distance = "mi";
      elevation ="ft";
    }
    return [pace, distance, elevation];
  };
  
const distanceInPreferredUnit = (distanceInKm) => {
    if (localStorage.getItem('unit') === 'mi') {
      return distanceInKm * 0.621371;
    }
    return distanceInKm;
  };
  
const elevationInPreferredUnit = (elevationInM) => {
    if (localStorage.getItem('unit') === 'mi') {
      return elevationInM * 3.280838879986877;
    }
    return elevationInM;
  };
  
const paceInPreferredUnit = (paceInKm) => {
    if (localStorage.getItem('unit') === 'mi') {
      return paceInKm / 0.62137099999751455037;
    }
    return paceInKm;
  };

const distanceInPreferredUnitV2 = (distanceInKm, userPrefUnits) => {
  if (userPrefUnits[1] === 'mi') {
    return distanceInKm * 0.621371;
  }
  return distanceInKm;
};
  
const elevationInPreferredUnitV2 = (elevationInM, userPrefUnits) => {
  if (userPrefUnits[1] === 'mi') {
    return elevationInM * 3.280838879986877;
  }
  return elevationInM;
};
  
const paceInPreferredUnitV2 = (paceInKm, userPrefUnits) => {
  if (userPrefUnits[1] === 'mi') {
    return paceInKm / 0.62137099999751455037;
  }
  return paceInKm;
};

const togglePreferredUnit = () => {
    if (localStorage.getItem('unit') === 'mi') {
      localStorage.setItem('unit','km');
    }
    else {
      localStorage.setItem('unit','mi');
    }
    return;
  };

const setPreferredUnit = (unit) => {
    if (!localStorage.getItem('unit')) {
      localStorage.setItem('unit','km');
    }
    else localStorage.setItem('unit', unit);
    
    // console.log(localStorage.getItem('unit'));
    return localStorage.getItem('unit');
  }

export {
    inImperial,
    unitLabels,
    distanceInPreferredUnit,
    elevationInPreferredUnit,
    paceInPreferredUnit,
    distanceInPreferredUnitV2,
    elevationInPreferredUnitV2,
    paceInPreferredUnitV2,
    togglePreferredUnit,
    setPreferredUnit,
  };